var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomePath2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 447 368",
    width: 447,
    height: 368,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m469.17 441.54h-1081.11v-607h1081.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 0.1,
    y1: 0.6,
    x2: 446.7,
    y2: 0.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fde0e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b6e8"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{opacity:.4;fill:url(#g1)}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m361.6 103.1c-0.8-0.3-1.3-1.1-1.3-1.9 0-55.5-45-100.6-100.5-100.6-39 0-72.7 22.2-89.4 54.5-1.8 3.4-5.4 5.4-9.2 5.1q-5.6-0.4-11.4-0.4c-83 0-150.3 67.6-149.7 150.7 0.5 82.7 67.6 149.1 150.3 148.8 12.3 0 24.3-1.6 35.8-4.4 24.9-6.3 51.1-5.1 75.2 3.9 14.8 5.5 30.7 8.6 47.4 8.7 75.6 0.3 137.5-60.9 137.9-136.6 0.4-57.7-34.9-107.2-85.1-127.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePath2);
export default __webpack_public_path__ + "static/media/homePath2.f0d78d837645ba1b8824e27dd781c67b.svg";
export { ForwardRef as ReactComponent };